import { Card } from "react-bootstrap";
import Spinner from "react-bootstrap/Spinner";
import FormAlert from "./FormAlert";
import { useEventEntriesByUid } from "./../util/db";
import { Link } from "react-router-dom";
import ScorecardSummaryTable5x4 from "./ScorecardSummaryTable5x4";

function DashboardScorecards({ uid }) {
  function formatDateMMDDYYYY(date) {
    const d = new Date(date);
    let month = "" + (d.getMonth() + 1);
    let day = "" + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [month, day, year].join("/");
  }

  const {
    data: eventEntries,
    status: eventEntriesStatus,
    error: eventEntriesError,
  } = useEventEntriesByUid(uid);

  return (
    <>
      {eventEntriesError && (
        <div className="mb-3">
          <FormAlert type="error" message={eventEntriesError.message} />
        </div>
      )}

      <Card className="mb-3">
        <Card.Header style={{ background: "#2D083F", color: "white" }}>
          <div className="d-flex align-items-center justify-content-between">
            <Card.Title className="mb-0" style={{ color: "white" }}>
              My Scorecards
            </Card.Title>
            {eventEntries && eventEntries.length > 0 && (
              <span
                style={{
                  backgroundColor: "rgba(255, 255, 255, 0.2)",
                  color: "white",
                  padding: "4px 12px",
                  borderRadius: "20px",
                  fontSize: "14px",
                  fontWeight: "600",
                }}
              >
                {eventEntries.length}{" "}
                {eventEntries.length === 1 ? "Scorecard" : "Scorecards"}
              </span>
            )}
          </div>
        </Card.Header>
        <Card.Body style={{ background: "#FFFFFF" }}>
          {eventEntriesStatus === "loading" && (
            <div className="py-3 text-center">
              <Spinner animation="border" variant="primary">
                <span className="sr-only">Loading...</span>
              </Spinner>
              <div className="mt-2 text-muted">Loading scorecards...</div>
            </div>
          )}

          {eventEntriesStatus !== "loading" &&
            eventEntries &&
            eventEntries.length === 0 && (
              <div className="py-4 text-center text-muted">
                <div className="mb-2">
                  <i className="fas fa-clipboard-list fa-2x mb-3"></i>
                </div>
                <div>No scorecards found</div>
                <small className="text-muted">
                  Scorecards from events you've played will appear here
                </small>
              </div>
            )}

          {eventEntriesStatus !== "loading" &&
            eventEntries &&
            eventEntries.length > 0 && (
              <div>
                {eventEntries.map((entry, index) => (
                  <div key={index}>
                    <div
                      className={`${
                        index < eventEntries.length - 1
                          ? "mb-4 pb-4 border-bottom"
                          : "mb-0"
                      }`}
                    >
                      <div className="mb-3">
                        <Link
                          to={`/event?event=${entry.events.id}`}
                          className="h5 mb-1 text-decoration-none d-block"
                          style={{ color: "#2D083F", fontWeight: "bold" }}
                        >
                          {entry.events.name}
                        </Link>
                        <small className="text-muted">
                          {formatDateMMDDYYYY(entry.events.date)}
                        </small>
                      </div>

                      <div className="scorecard-container">
                        <div className="p-3 bg-light rounded">
                          <ScorecardSummaryTable5x4
                            key={index}
                            eventEntryId={entry.id}
                            throwScoringModeId={
                              entry.events.throw_scoring_mode_id
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
        </Card.Body>
        <Card.Footer
          style={{
            background: "#2D083F",
            color: "white",
          }}
        />
      </Card>
    </>
  );
}

export default DashboardScorecards;
